"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCancellationFriendlyArray = void 0;
const pluralize_1 = require("../pluralize");
const getCancellationFriendlyArray = (discounts) => {
    const text = [];
    // first line always: Free cancellation until {HIGHEST_DEADLINE_ACROSS_ALL_DISCOUNTS} days before arrival.
    let highest_deadline = 0;
    discounts.forEach((discount) => {
        if (discount.deadline_days > highest_deadline) {
            highest_deadline = discount.deadline_days;
        }
    });
    text.push(`Free cancellation until ${highest_deadline} days before arrival.`);
    discounts.forEach((discount) => {
        if (discount.type === "PERCENTAGE") {
            if (discount.deadline_days === 0) {
                text.push(`Penalty of ${discount.penalty}% in the event of a no-show`);
            }
            else {
                text.push(`Penalty of ${discount.penalty}% if cancelled within ${discount.deadline_days} days of arrival`);
            }
        }
        if (discount.type === "NIGHTS") {
            text.push(`Penalty of ${(0, pluralize_1.pluralize)(discount.penalty, "night", "nights")} if cancelled within ${discount.deadline_days} days of arrival`);
        }
    });
    return text;
};
exports.getCancellationFriendlyArray = getCancellationFriendlyArray;
